export default "__VITE_ASSET__4E6ZxbaY__"